<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg12>
                <v-card>
                    <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                        <template v-slot:item="{ item }">
                            <tr>
                                <td>{{ item.ID }}</td>
                                <td>
                                    <v-chip small :color="getGroupColor(item.ServiceGroup)" dark>{{ getGroupName(item.ServiceGroup) }}</v-chip>
                                </td>
                                <td class="font-weight-medium">{{ item.ServiceName }}</td>
                                <td><code>{{ item.ServiceCode }}</code></td>
                                <td class="text-right">{{ item.Price | currency('', 0) }}</td>
                                <td>{{ item.Unit }}</td>
                                <td>
                                    <v-chip small :color="item.IsActive ? 'green' : 'grey'" dark>
                                        {{ item.IsActive ? 'Hoạt động' : 'Tắt' }}
                                    </v-chip>
                                </td>
                                <td>{{ item.CreatedDate | display_date }}</td>
                                <td class="text-center">
                                    <v-icon medium class="mr-2" @click="openItem(item.ID)" v-if="hasEditPermission">edit</v-icon>
                                    <v-icon medium @click="deleteItem(item.ID)" v-if="hasEditPermission">delete</v-icon>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>

        <!-- Dialog Thêm/Sửa -->
        <v-dialog v-model="dialogItem" max-width="700px">
            <v-card>
                <v-card-title>
                    <span class="title">{{ currentItem.ID ? 'Sửa dịch vụ' : 'Thêm dịch vụ' }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md pa-0>
                        <v-layout row wrap>
                            <v-flex lg6>
                                <v-text-field label="Tên dịch vụ" v-model="currentItem.ServiceName" :rules="requireRules"></v-text-field>
                            </v-flex>
                            <v-flex lg6>
                                <v-text-field label="Ký hiệu (code)" v-model="currentItem.ServiceCode" :rules="requireRules"></v-text-field>
                            </v-flex>
                            <v-flex lg4>
                                <v-select label="Nhóm dịch vụ" v-model="currentItem.ServiceGroup" :items="serviceGroups" item-text="name" item-value="value"></v-select>
                            </v-flex>
                            <v-flex lg4>
                                <v-text-field label="Chi phí" v-model="currentItem.Price" type="number"></v-text-field>
                            </v-flex>
                            <v-flex lg4>
                                <v-text-field label="Đơn vị tính" v-model="currentItem.Unit" placeholder="Tờ, KG, M3, RMB, VND"></v-text-field>
                            </v-flex>
                            <v-flex lg4>
                                <v-switch label="Hoạt động" v-model="currentItem.IsActive" :true-value="1" :false-value="0"></v-switch>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1 white--text" @click="dialogItem = false">Đóng</v-btn>
                    <v-btn v-if="hasEditPermission" @click="editItem">Lưu lại</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import createPermissionMixin from "@/mixins/permissionMixin";
import _ from "lodash";

export default {
    mixins: [createPermissionMixin('cn_service')],
    components: {
        "hpo-filter": Filtering
    },
    data() {
        return {
            viewName: "cn_service_list",
            dialogItem: false,
            serviceGroups: configs.CN_SERVICE_GROUP,
            headers: [
                { text: 'ID', value: "ID", filterable: true, dataType: configs.DATA_TYPE["Number"] },
                { text: 'Nhóm', value: "ServiceGroup", filterable: true, dataType: configs.DATA_TYPE["String"], quickSearch: true },
                { text: 'Tên dịch vụ', value: "ServiceName", filterable: true, dataType: configs.DATA_TYPE["String"], quickSearch: true },
                { text: 'Ký hiệu', value: "ServiceCode", filterable: true, dataType: configs.DATA_TYPE["String"], quickSearch: true },
                { text: 'Chi phí', value: "Price", filterable: true, dataType: configs.DATA_TYPE["Number"] },
                { text: 'Đơn vị', value: "Unit", filterable: false },
                { text: 'Trạng thái', value: "IsActive", filterable: true, dataType: configs.DATA_TYPE["Number"] },
                { text: 'Ngày tạo', value: "CreatedDate", filterable: true, dataType: configs.DATA_TYPE["Date"] },
                { text: 'Thao tác', value: "", align: "center", sortable: false, filterable: false }
            ],
            pagination: _.cloneDeep(configs.PAGINATION),
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            filterConditions: [],
            quickFilterConditions: [],
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
        };
    },
    watch: {
        pagination: {
            handler: function () {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : [];
                this.filter_data();
            },
            deep: true
        },
        loading() {
            this.$root.$emit('REQUEST_ROOT_OPTION', { invisibleCreateButton: !this.hasEditPermission });
        }
    },
    computed: {
        ...mapState({
            items: state => state.cnService.all.data,
            total_rows: state => state.cnService.all.total,
            loading: state => state.cnService.loading,
            currentItem: state => state.cnService.selected
        })
    },
    methods: {
        getGroupColor(group) {
            const colors = { HaiQuan: '#0059b3', VanChuyen: '#2d8659', ThanhToan: '#ff6a00', NoiDia: '#7b1fa2' };
            return colors[group] || '#808080';
        },
        getGroupName(group) {
            const found = this.serviceGroups.find(g => g.value === group);
            return found ? found.name : group;
        },
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("cnService/getList", param);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy;
            let sortDesc = this.pagination.sortDesc;
            this.pagination = _.cloneDeep(configs.PAGINATION);
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        openItem: function (id) {
            if (!this.hasEditPermission) return;
            if (!id) {
                this.$store.commit("cnService/setDetail", { ID: 0, IsActive: 1 });
            } else {
                this.$store.dispatch("cnService/getDetail", id);
            }
            this.dialogItem = true;
        },
        deleteItem: function (id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id);
        },
        editItem() {
            this.$store.dispatch("cnService/setDetail", {
                'data': { ...this.currentItem },
                'id': this.currentItem.ID
            });
            this.dialogItem = false;
        }
    },
    mounted() {
        this.$root.$on("REQUEST_CREATE_DATA", this.openItem);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("cnService/removeDetail", id);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA", this.openItem);
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>
